import script from "./RecordsTable.vue?vue&type=script&setup=true&lang=ts&generic=TRow%20extends%20RecordTableRow"
export * from "./RecordsTable.vue?vue&type=script&setup=true&lang=ts&generic=TRow%20extends%20RecordTableRow"

const __exports__ = script;

export default __exports__